function _isPlaceholder(a) {
  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

module.exports = _isPlaceholder;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isPlaceholder.js
// module id = 324
// module chunks = 0